/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CreateRoleRequest } from '../models/create-role-request';
import { MaterialTableRequestDto } from '../models/material-table-request-dto';
import { OperationResultDtoOfBoolean } from '../models/operation-result-dto-of-boolean';
import { OperationResultDtoOfRoleReadDto } from '../models/operation-result-dto-of-role-read-dto';
import { PagedResultDtoOfRoleReadDto } from '../models/paged-result-dto-of-role-read-dto';
import { RoleLookupDto } from '../models/role-lookup-dto';
import { RoleReadDto } from '../models/role-read-dto';
import { UpdateRoleRequest } from '../models/update-role-request';

@Injectable({
  providedIn: 'root',
})
export class RolesService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation rolesListRoles
   */
  static readonly RolesListRolesPath = '/api/roles/list';

  /**
   * List BNN roles.
   *
   * Returns a filtered and sorted page of BNN roles.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `rolesListRoles()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  rolesListRoles$Response(params: {
    body: MaterialTableRequestDto
  }): Observable<StrictHttpResponse<PagedResultDtoOfRoleReadDto>> {

    const rb = new RequestBuilder(this.rootUrl, RolesService.RolesListRolesPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PagedResultDtoOfRoleReadDto>;
      })
    );
  }

  /**
   * List BNN roles.
   *
   * Returns a filtered and sorted page of BNN roles.
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `rolesListRoles$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  rolesListRoles(params: {
    body: MaterialTableRequestDto
  }): Observable<PagedResultDtoOfRoleReadDto> {

    return this.rolesListRoles$Response(params).pipe(
      map((r: StrictHttpResponse<PagedResultDtoOfRoleReadDto>) => r.body as PagedResultDtoOfRoleReadDto)
    );
  }

  /**
   * Path part for operation rolesGetRoleLookup
   */
  static readonly RolesGetRoleLookupPath = '/api/roles/lookup';

  /**
   * Get BNN role lookup.
   *
   * Returns all BNN role IDs and names ordered by ID for selector controls.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `rolesGetRoleLookup()` instead.
   *
   * This method doesn't expect any request body.
   */
  rolesGetRoleLookup$Response(params?: {
  }): Observable<StrictHttpResponse<Array<RoleLookupDto>>> {

    const rb = new RequestBuilder(this.rootUrl, RolesService.RolesGetRoleLookupPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<RoleLookupDto>>;
      })
    );
  }

  /**
   * Get BNN role lookup.
   *
   * Returns all BNN role IDs and names ordered by ID for selector controls.
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `rolesGetRoleLookup$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  rolesGetRoleLookup(params?: {
  }): Observable<Array<RoleLookupDto>> {

    return this.rolesGetRoleLookup$Response(params).pipe(
      map((r: StrictHttpResponse<Array<RoleLookupDto>>) => r.body as Array<RoleLookupDto>)
    );
  }

  /**
   * Path part for operation rolesGetRole
   */
  static readonly RolesGetRolePath = '/api/roles/{id}';

  /**
   * Get BNN role.
   *
   * Returns every legacy permission field for one BNN role.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `rolesGetRole()` instead.
   *
   * This method doesn't expect any request body.
   */
  rolesGetRole$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<RoleReadDto>> {

    const rb = new RequestBuilder(this.rootUrl, RolesService.RolesGetRolePath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<RoleReadDto>;
      })
    );
  }

  /**
   * Get BNN role.
   *
   * Returns every legacy permission field for one BNN role.
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `rolesGetRole$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  rolesGetRole(params: {
    id: number;
  }): Observable<RoleReadDto> {

    return this.rolesGetRole$Response(params).pipe(
      map((r: StrictHttpResponse<RoleReadDto>) => r.body as RoleReadDto)
    );
  }

  /**
   * Path part for operation rolesUpdateRole
   */
  static readonly RolesUpdateRolePath = '/api/roles/{id}';

  /**
   * Update BNN role.
   *
   * Replaces a BNN role and reports post-commit integration warnings.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `rolesUpdateRole()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  rolesUpdateRole$Response(params: {
    id: number;
    body: UpdateRoleRequest
  }): Observable<StrictHttpResponse<OperationResultDtoOfRoleReadDto>> {

    const rb = new RequestBuilder(this.rootUrl, RolesService.RolesUpdateRolePath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OperationResultDtoOfRoleReadDto>;
      })
    );
  }

  /**
   * Update BNN role.
   *
   * Replaces a BNN role and reports post-commit integration warnings.
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `rolesUpdateRole$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  rolesUpdateRole(params: {
    id: number;
    body: UpdateRoleRequest
  }): Observable<OperationResultDtoOfRoleReadDto> {

    return this.rolesUpdateRole$Response(params).pipe(
      map((r: StrictHttpResponse<OperationResultDtoOfRoleReadDto>) => r.body as OperationResultDtoOfRoleReadDto)
    );
  }

  /**
   * Path part for operation rolesDeleteRole
   */
  static readonly RolesDeleteRolePath = '/api/roles/{id}';

  /**
   * Delete BNN role.
   *
   * Deletes an unassigned role and reports post-commit cache warnings.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `rolesDeleteRole()` instead.
   *
   * This method doesn't expect any request body.
   */
  rolesDeleteRole$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<OperationResultDtoOfBoolean>> {

    const rb = new RequestBuilder(this.rootUrl, RolesService.RolesDeleteRolePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OperationResultDtoOfBoolean>;
      })
    );
  }

  /**
   * Delete BNN role.
   *
   * Deletes an unassigned role and reports post-commit cache warnings.
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `rolesDeleteRole$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  rolesDeleteRole(params: {
    id: number;
  }): Observable<OperationResultDtoOfBoolean> {

    return this.rolesDeleteRole$Response(params).pipe(
      map((r: StrictHttpResponse<OperationResultDtoOfBoolean>) => r.body as OperationResultDtoOfBoolean)
    );
  }

  /**
   * Path part for operation rolesCreateRole
   */
  static readonly RolesCreateRolePath = '/api/roles';

  /**
   * Create BNN role.
   *
   * Creates a BNN role and reports post-commit integration warnings.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `rolesCreateRole()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  rolesCreateRole$Response(params: {
    body: CreateRoleRequest
  }): Observable<StrictHttpResponse<OperationResultDtoOfRoleReadDto>> {

    const rb = new RequestBuilder(this.rootUrl, RolesService.RolesCreateRolePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OperationResultDtoOfRoleReadDto>;
      })
    );
  }

  /**
   * Create BNN role.
   *
   * Creates a BNN role and reports post-commit integration warnings.
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `rolesCreateRole$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  rolesCreateRole(params: {
    body: CreateRoleRequest
  }): Observable<OperationResultDtoOfRoleReadDto> {

    return this.rolesCreateRole$Response(params).pipe(
      map((r: StrictHttpResponse<OperationResultDtoOfRoleReadDto>) => r.body as OperationResultDtoOfRoleReadDto)
    );
  }

}
